import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import { getMutationProps, getRangeMutationProps } from './DocumentAction';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import DispatchInstructions from 'graphql/entities/sales/DispatchInstructions';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Delivery note',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    DispatchInstructions.generate,
    getMutationProps(state, props, variables, 'dispatchInstruction'),
    props,
    returnUrl,
    'Generate Delivery Note',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    DispatchInstructions.generateRange,
    getRangeMutationProps(state, props, variables, 'dispatchInstructions', DispatchInstructions.workspaceUrl),
    props,
    returnUrl,
    'Generate Delivery Notes',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}
